/**
 * PageStatCards — one slim, flat row of figures above list pages (same on every module page).
 * Props unchanged: stats = [{ label, value, sub?, color? }]. `color` only tints the number for states that need
 * attention (orange / red / green); everything else is neutral.
 */
const TONE = {
  orange: "text-amber-700 dark:text-amber-400",
  red: "text-rose-600 dark:text-rose-400",
  green: "text-emerald-700 dark:text-emerald-400",
};

export function PageStatCards({ stats = [], loading = false }) {
  if (!stats || stats.length === 0) return null;
  return (
    <div className="grid grid-cols-2 divide-x divide-y divide-border overflow-hidden rounded-lg border border-border bg-card sm:grid-cols-4 sm:divide-y-0" data-testid="page-stat-cards">
      {stats.map((s, i) => (
        <div key={i} className="min-w-0 px-4 py-2.5" data-testid={`stat-card-${s.label?.toLowerCase().replace(/\s+/g, "-")}`}>
          <p className="truncate text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{s.label}</p>
          <div className={`mt-0.5 flex items-baseline gap-2 text-xl font-semibold tabular-nums ${TONE[s.color] || "text-foreground"}`}>
            {loading ? <span className="inline-block h-6 w-12 animate-pulse rounded bg-muted" /> : (s.value ?? 0)}
            {s.sub && !loading && <span className="truncate text-[11px] font-normal text-muted-foreground">{s.sub}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
